import script from "./LeaderProjectFormStep4.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectFormStep4.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectFormStep4.vue?vue&type=style&index=0&id=7516acac&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7516acac"]])

export default __exports__